import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { trackPageView } from './utils/analytics';
import HomePage from './pages/HomePage';
import RegisterPage from './pages/RegisterPage';
import LoginPage from './pages/LoginPage';
import CreateAdPage from './pages/CreateAdPage/CreateAdPage';
import Navbar from './components/Navbar';
import CookieConsentBanner from './components/CookieConsentBanner';
import AdDetailPage from './pages/AdDetailPage';
import BuyPage from './pages/BuyPage';
import RentPage from './pages/RentPage';
import DailyPage from './pages/DailyPage';
import CommercialPage from './pages/CommercialPage';
import RulesPage from './pages/RulesPage';
import NewsPage from './pages/NewsPage';
import NewsDetailPage from './pages/NewsDetailPage';
import ArticlesPage from './pages/ArticlesPage';
import ArticleDetailPage from './pages/ArticleDetailPage';
import UsefulLinksPage from './pages/UsefulLinksPage';
import ProfilePage from './pages/ProfilePage';
import SellerProfilePage from './pages/SellerProfilePage';
import CatalogPage from './pages/CatalogPage';
import CityHubPage from './pages/CityHubPage';
import RecentlyViewedPage from './pages/RecentlyViewedPage';
import RequireAdmin from './components/RequireAdmin';
import AdminLayout from './pages/admin/AdminLayout';
import AdminReportsPage from './pages/admin/AdminReportsPage';
import AdminAdsPage from './pages/admin/AdminAdsPage';
import AdminImportPage from './pages/admin/AdminImportPage';
import AdminCommentsPage from './pages/admin/AdminCommentsPage';
import AdminUsersPage from './pages/admin/AdminUsersPage';
import AdminUserDetailPage from './pages/admin/AdminUserDetailPage';
import AdminNewsPage from './pages/admin/AdminNewsPage';
import AdminArticlesPage from './pages/admin/AdminArticlesPage';
import AdminUsefulLinksPage from './pages/admin/AdminUsefulLinksPage';
import 'bootstrap/dist/css/bootstrap.min.css';

function PageViewTracker() {
    const location = useLocation();
    useEffect(() => {
        trackPageView(location.pathname + location.search);
    }, [location.pathname, location.search]);
    return null;
}

function App() {
    return (
        <Router>
            <PageViewTracker />
            <Navbar />
            <CookieConsentBanner />
            <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/register" element={<RegisterPage />} />
                <Route path="/login" element={<LoginPage />} />
                <Route path="/create" element={<CreateAdPage />} />
                <Route path="/edit/:id" element={<CreateAdPage />} />
                <Route path="/ad/:id" element={<AdDetailPage />} />
                <Route path="/buy" element={<BuyPage />} />
                <Route path="/rent" element={<RentPage />} />
                <Route path="/daily" element={<DailyPage />} />
                <Route path="/commercial" element={<CommercialPage />} />
                <Route path="/rules" element={<RulesPage />} />
                <Route path="/news" element={<NewsPage />} />
                <Route path="/news/:slug" element={<NewsDetailPage />} />
                <Route path="/articles" element={<ArticlesPage />} />
                <Route path="/articles/:slug" element={<ArticleDetailPage />} />
                <Route path="/useful-links" element={<UsefulLinksPage />} />
                <Route path="/profile" element={<ProfilePage />} />
                <Route path="/profile/:userId" element={<SellerProfilePage />} />
                <Route path="/catalog" element={<CatalogPage />} />
                <Route path="/recently-viewed" element={<RecentlyViewedPage />} />
                {/* SEO-friendly catalog paths: /{dealSlug}/{kindSlug?}/{citySlug?} */}
                <Route path="/kupit/:kindSlug?/:citySlug?" element={<CatalogPage prettyDealType="0" />} />
                <Route path="/snyat/:kindSlug?/:citySlug?" element={<CatalogPage prettyDealType="1" />} />
                <Route path="/posutochno/:kindSlug?/:citySlug?" element={<CatalogPage prettyDealType="2" />} />
                <Route path="/kommercheskaya-arenda/:kindSlug?/:citySlug?" element={<CatalogPage prettyDealType="3" />} />
                <Route path="/kommercheskaya-prodazha/:kindSlug?/:citySlug?" element={<CatalogPage prettyDealType="4" />} />
                <Route path="/nedvizhimost/:citySlug" element={<CityHubPage />} />
                <Route path="/admin/ads/edit/:id" element={<RequireAdmin><CreateAdPage /></RequireAdmin>} />
                <Route path="/admin" element={<RequireAdmin><AdminLayout /></RequireAdmin>}>
                    <Route path="reports" element={<AdminReportsPage />} />
                    <Route path="ads" element={<AdminAdsPage />} />
                    <Route path="import" element={<AdminImportPage />} />
                    <Route path="comments" element={<AdminCommentsPage />} />
                    <Route path="users" element={<AdminUsersPage />} />
                    <Route path="users/:id" element={<AdminUserDetailPage />} />
                    <Route path="news" element={<AdminNewsPage />} />
                    <Route path="articles" element={<AdminArticlesPage />} />
                    <Route path="useful-links" element={<AdminUsefulLinksPage />} />
                </Route>
            </Routes>
        </Router>
    );
}

export default App;
